<template>
  <span class="magicLinkButtonContainer">
    <div class="dividerContainer">
      <div class="dividerWithText">
        <span>{{ t('or') }}</span>
      </div>
    </div>

    <span class="buttonContainer" @click="openEmailLink">
      <button
        class="amplify-button amplify-field-group__control amplify-authenticator__font eidButton magicLinkButton"
      >
        <VIcon class="pr-2" icon="mdi-email" />
        {{ t('sign-in-with-email-link') }}
      </button>
    </span>
  </span>

  <MagicLinkRequestDialog
    :showDialog="showMagicLinkDialog"
    @close="closeMagicLink"
  />
</template>

<script setup lang="js">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import MagicLinkRequestDialog from './magic_link_request_dialog.vue';

const { t } = useI18n();

const showMagicLinkDialog = ref(false);
/** */
function openEmailLink() {
  showMagicLinkDialog.value = true;
}
/** */
function closeMagicLink() {
  showMagicLinkDialog.value = false;
}
</script>

<i18n>
  {
    "en": {
      "sign-in-with-email-link": "Sign in with Email Link",
      "or": "OR",
    },
    "es": {
      "sign-in-with-email-link": "Enviar Enlace para Iniciar Sesión",
      "or": "O",
    }
  }
</i18n>
